<template>
  <div class="service-overview">
    <div class="container mx-auto lg:py-20 py-10 px-3 flex lg:flex-row flex-col gap-8">
      <div class="lg:w-1/2 max-h-[85%] relative">
        <img :src="data.images?.other" class="w-full lg:h-[85%] h-[400px]" />
        <div
          class="absolute lg:bottom-5 bottom-0 lg:right-6 w-full w-full lg:w-[30%] lg:h-[26%] p-1 text-white bg-secondary ">
          <div class="bg-secondary flex justify-center items-center p-3 rounded-sm max-h-[100px]">
            <img src="../../assets/v-1.1/user_icon.svg" class="object-fill w-[80px] h-[80px]" />
          </div>
          <div class="font-semibold lg:text-lg text-base text-center lg:mt-1">24 Hours</div>
          <div class="lg:text-base text-sm text-center">Emergency Service</div>
        </div>
      </div>
      <div class="flex flex-col justify-start lg:w-1/2 lg:gap-8 gap-3">
        <div class="text-lg font-semibold text-primary">
          Service Overview
        </div>
        <div class="lg:text-4xl text-2xl font-bold font-primary">
          {{ data?.service_overview?.title }}
        </div>
        <div class="text-base text-grey">
          {{ data?.service_overview?.description }}
        </div>
        <div class="grid sm:grid-cols-2 grid-cols-1 gap-y-4">
          <div class="flex items-center gap-3" v-for="item, index in elements" :key="index">
            <img src="../../assets/v-1.1/Icons/tick-yellow.svg" class="w-[20px] h-[20px]" />
            <span class="font-semibold">{{ item }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script setup>
const elements = [
  "Customized Approach", "Attention to Detail", "Skilled and Licensed", "Excellent Customer Service", "Wide Range of Services", "Flexibility", "Latest Technology", "Cost-effective Solutions",
];

defineProps({
  data: Object,
});
</script>

<style scoped>
.service-overview {
  background-image: url("../../assets/v-1.1/service-overview-banner.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>